import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { ITjipDirectiveOptions } from './ITjipDirectiveOptions';

class TjipDirectiveDataBase {
  protected el!: Element;
  protected binding!: DirectiveBinding;
  protected vnode!: VNode;
  protected oldVnode!: VNode;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get componentInstance(): any {
    return this.vnode && this.vnode.componentInstance;
  }

  public init(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
    this.el = el;
    this.binding = binding;
    this.vnode = vnode;
    this.oldVnode = oldVnode;
  }

  public bind() {
    Vue.$log.debug(this.id, this);
  }

  public inserted() {
    Vue.$log.debug(this.id, this);
  }

  public update() {
    Vue.$log.debug(this.id, this);
  }

  public componentUpdated() {
    Vue.$log.debug(this.id, this);
  }

  public unbind() {
    Vue.$log.debug(this.id, this);
  }

  protected get id(): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.vnode.componentInstance as any)._uid;
  }
}

export class TjipDirectiveData<T extends ITjipDirectiveOptions> extends TjipDirectiveDataBase {
  protected options!: T;

  public setOptions(options: T) {
    this.options = options;
  }
}

export function tjipDirective<T extends TjipDirectiveData<O>, O extends ITjipDirectiveOptions>(
  cls: typeof TjipDirectiveDataBase,
  options?: O
) {
  const directiveData: { [id: string]: T } = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const id = (vnode: VNode) => (vnode.componentInstance as any)._uid;

  const data = (el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode): T => {
    let result = directiveData[id(vnode)];
    if (!result) {
      result = directiveData[id(vnode)] = new cls() as T;
      result.setOptions(options || ({} as O));
    }
    result.init(el, binding, vnode, oldVnode);
    return result;
  };

  return {
    bind(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
      data(el, binding, vnode, oldVnode).bind();
    },
    inserted(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
      data(el, binding, vnode, oldVnode).inserted();
    },
    update(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
      data(el, binding, vnode, oldVnode).update();
    },
    componentUpdated(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
      data(el, binding, vnode, oldVnode).componentUpdated();
    },
    unbind(el: Element, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
      data(el, binding, vnode, oldVnode).unbind();
      delete directiveData[id(vnode)];
    }
  };
}
